export default "__VITE_ASSET__CftCRTdp__"